import { ok } from "@ps-bridge/ok";
import { useTaskOnChange } from "@hooks/effects/useTaskEffect";
import { taskFromRaw } from "@utils/effects/branded";

export const useListingInferenceReviewPortalLoad = (
  loadWorkspace: () => Promise<import("@ps-bridge/ok").Ok>,
  reloadToken: number,
) => {
  useTaskOnChange(taskFromRaw(() => loadWorkspace().then(() => ok)), [loadWorkspace, reloadToken]);
  return ok;
};
